import React from "react";
import { Button, Modal } from "react-bootstrap";
import { delete_faq_question } from "../reduxData/user/userAction";
import { useDispatch } from "react-redux";
import { get_all_faq_questions } from "../reduxData/cms/cmsAction";
import { useTranslation } from "react-i18next";

const DeleteContent = ({ show, handleClose, data, heading, otherLine, isFaq, currentQuest }) => {
    const dispatch = useDispatch();
    const { t } = useTranslation();

    // handle user deative and delete faq question
    const handleDelete = async () => {
        let faq_delete = await delete_faq_question(data?.id, dispatch);
        if (faq_delete) {
            await get_all_faq_questions(currentQuest, dispatch);
            handleClose();
        }
    };

    return (
        <Modal show={show} centered>
            <Modal.Body>
                <Modal.Title>{t("cms.faqNl.deleteQuestion")}</Modal.Title>
                <span className="fw-200 mt-1">
                    {t("cms.faqNl.deleteConfirmation")} {otherLine}?
                </span>
                <div className="d-flex justify-content-space-between gap-2 mt-3">
                    <Button type="submit" className="btn common-button" onClick={handleClose}>{t("cms.faqNl.cancel")}</Button>
                    <Button className="question-button" variant="danger" onClick={handleDelete}>{t("cms.faqNl.delete")}</Button>
                </div>
            </Modal.Body>
        </Modal>
    )
};

export default DeleteContent;

